<template>
  <div class="headerBox">
    <StoreHeader v-if="isStore"
      class="headerBox"
      :style="responsive === 'tablet' && {...menuBg, color: setColors.menuText}"
      :locale="locale"
      :lang="lang"
      :responsive="responsive"
      :roomKey="roomKey"
      :setting="setting"
      :isPublic="isPublic" />
    <div v-else class="headerBox"
      :class="{open: dimmed}"
      :style="responsive === 'tablet' && {...menuBg, color: setColors.menuText}">
      <div id="gnb"
        :style="responsive !== 'tablet' && headerBg"
        :data-type="roomInfoType"
        :class="{scrollDown: roomKey && scrollMove === 'down'}">
        <router-link :to="{name: 'main', params: {id: setting.main.page, ln: setLang}}" class="home">
          <span><img :src="setting.logo" :alt="setting.title[lang]"></span>
        </router-link>
        <div v-if="roomKey && !disabledMypageAll" class="roomKeyInfo notranslate"
          :class="{roomOnly: mypage.disabledMypage && !mypage.disabledRoom, mypageOnly: !mypage.disabledMypage && mypage.disabledRoom}">
          <router-link
            v-if="mypage ? (!mypage.disabledMypage && !mypage.disabledRoom) : true" :to="{name: 'mypage'}"
            class="mr5"
            @click.native="setActiveMenuDefault">
            <span class="no">{{roomKey || ''}}</span>
          </router-link>
          <span v-else-if="mypage.disabledMypage && !mypage.disabledRoom" class="no mr5">{{roomKey || ''}}</span>
          <router-link
            v-if="mypage ? !mypage.disabledMypage : true" :to="{name: 'mypage'}"
            class="roomNumber"
            @click.native="setActiveMenuDefault">
            <span class="mp toCapitalize"
              :style="{
                ...(globalIconType === 'border' ? skinStyle('mypageBg', 'border-color') : skinStyle('mypageBg', 'background-color')),
                ...skinStyle('mypageText', 'color') }">
              <div class="utilIcon icoMypage" :style="{ ...skinStyle('mypageText', 'background-color')}"></div>
              {{locale.mypage}}
            </span>
          </router-link>
          <router-link
            v-if="mypage ? !mypage.disabledCart : true"
            :to="{name: 'cart'}"
            :style="{ ...responsive === 'tablet' && (globalIconType === 'border' ? skinStyle('mypageBg', 'border-color') : skinStyle('mypageBg', 'background-color'))}"
            @click.native="setActiveMenuDefault"
            class="btnCart">
            <div class="utilIcon icoCart" :style="{ ...skinStyle('mypageText', 'background-color')}"></div>
            <i v-if="cartItem && cartItem > 0" :style="{ ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{cartItem}}</i>
          </router-link>
        </div>
        <SetLanguage
          :locale="locale"
          :responsive="responsive"
          :setting="setting"
          :lang="lang" />
      </div>
      <button type="button" class="btnMenu" @click="onClickMenu">
        <span class="bar" :style="{backgroundColor: setColors.menuBtn}"></span>
        <span class="bar" :style="{backgroundColor: setColors.menuBtn}"></span>
        <span class="bar" :style="{backgroundColor: setColors.menuBtn}"></span>
      </button>
      <Nav id="nav"
        :locale="locale"
        :responsive="responsive"
        :lang="lang"
        :menu="menu"
        :style="responsive !== 'tablet' && {...menuBg, color: setColors.menuText}"
        :data-active_menu="activeMenuType" />
      <!-- <Checkout id="checkout"
        v-if="isCheckout && metaInfo"
        :lang="lang"
        :locale="locale"
        :metaInfo="metaInfo"
        :checkoutTime="checkoutTime"
        @close="toggleCheckout(false)" /> -->
      <div class="dimm" v-if="dimmed" @click.stop="onClickDimm" :style="{backgroundColor: setColors.dimm}"></div>
    </div>
  </div>
</template>

<script>
import Nav from '@/views/Nav'
import StoreHeader from '@/views/StoreHeader'
// import Checkout from '@/components/Nav/Checkout.vue'
import SetLanguage from '@/components/Util/SetLanguage'
import moment from 'moment-timezone'
import { DateTime } from 'luxon'

let lastScrollTop = 0

export default {
  name: 'Header',
  props: [
    'responsive',
    'roomKey',
    'setting',
    'lang',
    'locale',
    'isPublic'
  ],
  components: {
    Nav,
    // Checkout,
    SetLanguage,
    StoreHeader
  },
  computed: {
    dimmed () {
      return this.$store.state.dimmed
    },
    globalIconType () {
      const pointcolors = this.setting && this.setting.pointcolors
      return (pointcolors && pointcolors.globalIconType) || 'bg'
    },
    menu () {
      return this.$store.getters['common/getMenu']
    },
    ln () {
      return this.$route.params.ln
    },
    disabledMypageAll () {
      const mypage = this.mypage
      return mypage && mypage.disabledRoom && mypage.disabledMypage && mypage.disabledCart
    },
    format () {
      const setting = this.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm'
      return `${date} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    setLang: {
      get () {
        return this.ln
      },
      set (ln) {
        this.$store.dispatch('common/setLang', ln)
        this.$store.commit('system/setLocale', ln)
      }
    },
    setColors () {
      return {
        dimm: this.setting.colors.dimm,
        headerBg: this.setting.colors.headerBg,
        menuBtn: this.dimmed ? this.setting.colors.menuBtn2 : this.setting.colors.menuBtn,
        menuBg: this.setting.colors.menuBg,
        menuText: this.setting.colors.menuText
      }
    },
    headerBg () {
      return {
        backgroundColor: this.setting.colors.headerBg,
        backgroundImage: this.setting.imgs ? `url(${this.setting.imgs.headerBg})` : '',
        backgroundSize: this.setting.imgs ? this.setting.imgs.headerBgSize : '',
        backgroundRepeat: this.setting.imgs ? this.setting.imgs.headerBgRepeat : '',
        backgroundPosition: this.setting.imgs ? this.setting.imgs.headerBgPosition : ''
      }
    },
    menuBg () {
      return {
        backgroundColor: this.setting.colors.menuBg,
        backgroundImage: this.setting.imgs ? `url(${this.setting.imgs.menuBg})` : '',
        backgroundSize: this.setting.imgs ? this.setting.imgs.menuBgSize : '',
        backgroundRepeat: this.setting.imgs ? this.setting.imgs.menuBgRepeat : '',
        backgroundPosition: this.setting.imgs ? this.setting.imgs.menuBgPosition : ''
      }
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    cartItem () {
      return this.$store.getters['cart/getList']().length
    },
    mypage () {
      return this.setting.mypage || null
    },
    roomInfoType () {
      const info = this.mypage
      let type = 0
      if (info.disabledCart && !info.disabledMypage) {
        type = 1
      } else if (!info.disabledCart && info.disabledMypage) {
        type = 1
      } else if (info.disabledCart && info.disabledMypage) {
        type = 2
      } else if (this.invalidOta || !this.roomKey) {
        type = 2
      }
      return type
    },
    activeMenuType () {
      const skin = this.setting && this.setting.skin
      return (skin && skin.activeMenuType) || 'default'
    },
    invalidOta () {
      const isInvalid = this.$store.state.authentication.otavalid && this.$store.state.authentication.otavalid === 'false'
      return isInvalid
    },
    isStore () { // 상품페이지의 1뎁스카테고리를 내비게이션으로 사용
      return this.$route.name === 'store'
    }
  },
  created () {
    // this.$store.dispatch('authentication/supportCheckout').then((res) => {
    //   if (res.status === 200) {
    //     this.checkoutTime = res.message
    //     this.$store.dispatch('authentication/getMetaInfo').then((res) => {
    //       if (res) {
    //         this.metaInfo = res
    //         this.observeCheckout()
    //       }
    //     })
    //   }
    // })
  },
  beforeDestroy () {
    clearInterval(this.checkoutInterval)
  },
  async mounted () {
    // window.addEventListener('scroll', this.scrollBody)
  },
  data () {
    return {
      openLang: false,
      isCheckout: false,
      scrollMove: null,
      checkoutTime: null,
      availCheckout: false,
      checkoutInterval: 0,
      metaInfo: null,
      canCheckout: null
    }
  },
  methods: {
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    scrollBody () {
      let scrollTop = window.scrollY
      const result = (scrollTop >= 120) && (scrollTop >= lastScrollTop) ? 'down' : 'up'
      const toggle = result === 'down' ? 'add' : 'remove'
      this.scrollMove = result
      document.body.classList[toggle]('scrollDown')
      lastScrollTop = scrollTop
    },
    selectLang () {
      this.openLang = !this.openLang
      document.addEventListener('click', this.closeSelectLang)
    },
    closeSelectLang (e) {
      if (e.target.closest('.countryList') === null) {
        this.openLang = false
        document.removeEventListener('click', this.closeSelectLang)
      }
    },
    onClickMenu () {
      const dimmed = !this.dimmed
      this.$store.commit('dimmed', dimmed)
    },
    preCheckCheckout () {
      this.$store.dispatch('authentication/canCheckout')
    },
    toggleCheckout (toggle) {
      if (this.metaInfo !== null && this.metaInfo.stayBefore) {
        const timeFrom = this.dateformat(moment(this.metaInfo.stayBefore).set({ 'hour': this.checkoutTime.fromHour, 'minute': this.checkoutTime.fromMin }).toISOString())
        const timeTo = this.dateformat(moment(this.metaInfo.stayBefore).set({ 'hour': this.checkoutTime.toHour, 'minute': this.checkoutTime.toMin }).toISOString())
        /**
         * 체크아웃 가능시간 비교하여
         * 사전 체크아웃 여부 확인
         * 모두 ok 이면 self checkout process
         */
        if (this.availCheckout) {
          this.$store.dispatch('authentication/canCheckout').then((res) => {
            if (res.message === 'ok') {
              const overflow = toggle ? 'hidden' : 'auto'
              this.isCheckout = toggle || !this.isCheckout
              // document.body.style.overflow = overflow
            } else if (res.message === 'e_front') {
              // alert('결제하실 금액이 확인되었습니다.\n프론트로 방문하여 체크아웃 해주세요.')
              alert(`${this.locale.alert_checkout_pay}\n${this.locale.alert_checkout_front}`)
            } else if (res.message === 'e_system') {
              // alert('시스템에러가 발생했습니다.\n프론트로 방문하여 체크아웃 해주세요.')
              alert(`${this.locale.alert_system_error}\n${this.locale.alert_checkout_front}`)
            } else if (res.message === 'e_checkout') {
              // alert('체크아웃 처리된 객실입니다.')
              alert(`${this.locale.alert_checkout_already}`)
              this.metaInfo = null
            } else if (res.message === 'e_expired') {
              // alert('체크아웃 기간이 지났습니다.')
              alert(`${this.locale.alert_checkout_expired}`)
            }
          })
        } else {
          alert(`${this.locale.alert_checkout_time}\n${this.locale.alert_checkout_times}: ${timeFrom} ~ ${timeTo}`)
        }
      }
    },
    onClickDimm () {
      this.$store.commit('dimmed', false)
    },
    dateformat (iso) {
      const datetime = DateTime.fromISO(iso)
      return datetime.toFormat(this.format)
    },
    // 1초마다 체크아웃 가능시간 체크
    observeCheckout () {
      this.checkoutInterval = setInterval(() => {
        const now = moment()
        const timeNow = Number(now.tz(this.timezone).format('HHmm'))
        const timeFrom = Number(String(this.checkoutTime.fromHour) + String(this.checkoutTime.fromMin))
        const timeTo = Number(String(this.checkoutTime.toHour) + String(this.checkoutTime.toMin))
        const checkout = moment(this.metaInfo.stayBefore)
        const isAfter = now.isAfter(checkout)
        const isToday = now.isSame(checkout, 'day')
        const isTime = timeNow >= timeFrom && timeNow <= timeTo
        this.availCheckout = isToday && isTime
        // console.log(`timeNow: ${timeNow}\n\
        // availableTime: ${timeFrom} ~ ${timeTo}\n\
        // isToday: ${isToday}\n\
        // isTime: ${isTime}\n\
        // availCheckout: ${isToday && isTime}`)
        if (isAfter) {
          this.metaInfo = null
          clearInterval(this.checkoutInterval)
        }
      }, 1000)
    },
    // 활성화메뉴 초기화
    setActiveMenuDefault () {
      this.$store.commit('setActiveMenu', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.roomKeyInfo {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 15px;
  font-size: 18px;
  font-weight: 700;
  color: $color-dark;
  background-color: $color-white;
  overflow: hidden;
  transition: all 0.5s;
  transition-delay: 0.5s;
  .roomNumber {
    span {
      display: inline-block;
      vertical-align: middle;
    }
    .no {
      margin-right: 5px;
    }
    .mp {
      padding: 6px 10px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1;
      color: $color-white;
      border: 1px solid transparent;
      border-radius: 50px;
      background-color: transparent;
    }
  }
  .checkout {
    margin-left: auto;
    margin-right: 5px;
    padding: 6px 10px;
    font-size: 14px;
    color: $color-primary;
    line-height: 1;
    border: 1px solid $color-primary;
    border-radius: 50px;
    background-color: $color-white;
    &.disabled {
      color: $color-lgrey;
      border-color: $color-lgrey;
    }
  }
  .btnCart {
    position: relative;
    width: 32px;
    height: 32px;
    margin-left: auto;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    border: 1px solid transparent;
    background: url('~@/assets/img/ico_cart.png') 50% 50% / contain no-repeat;
    i {
      position: absolute;
      top: 0;
      right: 0;
      min-width: 17px;
      height: 17px;
      margin-top: 0;
      margin-right: -4px;
      padding: 3px 5px;
      text-align: center;
      color: $color-white;
      border-radius: 30px;
      background-color: $color-primary;
    }
  }
}
@media screen and (max-width: 767px) {
  .scrollDown .roomKeyInfo {
    height: 0;
    transition-delay: 0.8s;
  }
}
@media screen and (min-width: 768px) {
  .roomKeyInfo {
    background: none;
    .no {
      text-shadow: -1px -1px 0 $color-white, 1px -1px 0 $color-white, -1px 1px 0 $color-white, 1px 1px 0 $color-white;
    }
    .btnCart {
      background-image: none;
    }
  }
  @media screen and (max-width: 1023px) {
    .roomKeyInfo {
      display: block;
      position: relative;
      height: auto;
      padding-left: 10px;
      padding-right: 10px;
      overflow: visible;
      z-index: 1;
      .roomNumber {
        display: inline-block;
        text-align: center;
        .no {
          display: block;
          margin-right: 0;
          padding: 5px;
          &:before {
            content: "";
            display: block;
            width: 40px;
            height: 30px;
            margin: 0 auto;
            background: url('~@/assets/img/ico_user.svg') 50% 50% / contain no-repeat;
          }
        }
      }
      .btnCart {
        position: absolute;
        top: 100%;
        right: 10px;
        margin-top: 5px;
      }
      .roomNumber + .btnCart {
        // margin-top: 7px;
      }
    }
  }
  @media screen and (max-width: 799px) {
    .roomKeyInfo {
      padding-left: 4px;
      padding-right: 4px;
      .roomNumber {
        display: block;
        text-align: center;
        .mp {
          display: block;
          padding-left: 4px;
          padding-right: 4px;
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
